import React from 'react';

// tslint:disable:max-line-length
const JoinIcon = (props) => (
  <svg width={12} height={12} viewBox="0 0 12 12" {...props}>
    <g fill={props.color || 'currentColor'} fillRule="nonzero">
      <path d="M6.134 5.623c1.008 0 1.855-.89 1.855-2.024 0-1.133-.847-2.023-1.855-2.023-1.007 0-1.855.89-1.855 2.023s.848 2.024 1.855 2.024zm0 1.5c-1.852 0-3.355-1.578-3.355-3.524S4.282.076 6.134.076c1.853 0 3.355 1.577 3.355 3.523 0 1.946-1.502 3.524-3.355 3.524z" />
      <path d="M6 7.125V5.618c-2.738 0-5.003 2.107-5.617 4.867H1.93C2.47 8.612 4.228 7.239 6 7.125zm-1.003 3.36c.079 0 .157.006.233.018l-.233 1.482H.219c0-.467.047-.924.136-1.365l.162-.508c0-.524 1.117-.369 1.412.373h3.068zm.765-3.36L6 5.618c-2.738 0-5.003 2.107-5.617 4.867H1.93c.54-1.873 2.061-3.246 3.833-3.36zm-.765 3.36c.079 0 .157.006.233.018l-.233 1.482H.219c0-.467.047-.924.136-1.365l1.364 1.365c0-.524.074-1.028.21-1.5h3.068z" />
      <path d="M3.5 12h2a.75.75 0 1 0 0-1.5h-2a.75.75 0 1 0 0 1.5zm6.38-3.55v-.97a.75.75 0 0 0-1.5 0v.97H7.3a.75.75 0 0 0 0 1.5h1.08v1.03a.75.75 0 0 0 1.5 0V9.95h.92a.75.75 0 0 0 0-1.5h-.92z" />
    </g>
  </svg>
);
// tslint:enable:max-line-length

export default JoinIcon;



// WEBPACK FOOTER //
// ./app/common/components/canonical-components/icons/JoinIcon.js